const styles = theme => ({
    dialogRoot: {
        minWidth: 350
    },
    dialogOpen: {
        overflow: 'hidden'
    },
    appBar: {
    },
    flex: {
        flex: 1,
    },
    grow: {
        flexGrow: 1,
    },
    panel: {
        overflow: 'auto'
    }
});

export default styles;